import { Injectable, inject } from '@angular/core';
import { SupabaseClient } from '@supabase/supabase-js';
import { Announcement } from '@app/model/announcement';
import { SUPABASE_CLIENT } from '@app/providers/supabase.provider';

@Injectable({
  providedIn: 'root'
})
export class AnnouncementService {

  private supabaseClient: SupabaseClient;

  constructor() {
    this.supabaseClient = inject(SUPABASE_CLIENT);
  }

  // 過期公告由資料庫排程每分鐘下架並通知，這裡只回傳尚未到期的公告
  async getAllAnnouncements() {
    const res = await this.supabaseClient
      .from('announcement')
      .select('*')
      .gt('expire_time', new Date().toISOString());
    return res?.data;
  }

  async getAnnouncementById(announcementId: string) {
    const res = await this.supabaseClient.from('announcement').select('*').eq('id', announcementId);
    return res?.data?.[0];
  }

  async createAnnouncement(announcement: Announcement) {
    const res = await this.supabaseClient.from('announcement').insert({
      title: announcement.title, description: announcement.description, image_url: announcement.image_url, expire_time: announcement.expire_time, is_pin: announcement.is_pin, location: announcement.location
    });
    return res;
  }
}
